export const voucherCodeSelector = (state: Object) => state.voucher.externalId;

export const voucherAmountSelector = (state: Object) => state.voucher.amount;
